import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import apiClient from "../api.js";
import Canonical from "../components/Canonical.js";

export default function BlogPage() {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);

  useEffect(() => {
    apiClient.get(`blog/singleblog/${slug}`).then((res) => setBlog(res.data));
  }, [slug]);

  if (!blog) return <p>Loading...</p>;

  const canonicalUrl = `https://homesdekho.com/blog-post/${blog.slug}`;
  const metaTitle = blog.metatitle || blog.title;
  const hrfLangTag = `https://homesdekho.com/blog-post/${blog.slug}`;
  const description =
    blog.metadescription || blog.content.substring(0, 150) + "...";

  return (
    <>
      <Canonical
        canonicalUrl={canonicalUrl}
        title={metaTitle}
        description={description}
        hrfLang={hrfLangTag}
      />

      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <h1 className="mt-4">{blog.title}</h1>
            <div className="blog-image">
              <img
                src={blog.blogimage}
                alt={blog.title}
                className="img-fluid"
              />
            </div>
            <div className="overflow-x-scroll">
              <div
                dangerouslySetInnerHTML={{
                  __html: DOMPurify.sanitize(blog.content),
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
